module.exports = __webpack_public_path__ + "img/vida-verd-02.a994f2cf.jpg";